// extracted by mini-css-extract-plugin
export default {"headerCell":"TableHead_headerCell__g8i69","loadingCell":"TableHead_loadingCell__mWqKj"};